<template>
  <section>
    <v-toolbar>
      <v-toolbar-title class="headline d-flex mr-4">
        <v-icon class="pr-2 align-self-center" color="grey" large
          >mdi-message-text</v-icon
        >
        <span class="align-self-center">Messages</span>
      </v-toolbar-title>
      <v-btn
        color="error"
        icon
        @click="confirmDelete = true"
        v-if="selectedMessages.length"
      >
        <v-icon>mdi-delete</v-icon>
      </v-btn>

      <v-spacer></v-spacer>

      <v-menu
        bottom
        left
        :close-on-click="!search"
        :close-on-content-click="false"
        :offset-y="false"
        v-if="messagesTotal"
      >
        <template v-slot:activator="{ on }">
          <v-btn color icon v-on="on" title="Export">
            <v-icon>mdi-export</v-icon>
          </v-btn>
        </template>
        <v-toolbar flat dense>
        <!--<v-btn outlined class="mx-2" color="primary">Export Filtered</v-btn>-->
        <v-btn outlined class="mx-2" color="primary" :href="exportURL()">{{dateFilterRange && dateFilterRange.length ? 'Export All (date range)' : 'Export All'}}</v-btn>
        <v-btn outlined class="mx-2" color="primary" :href="exportURL('action_filtered')" v-if="actionFilter && actionFilter.length">Export Action Filtered</v-btn>
        <div style="width: 100px;">
          <v-select
            v-model="exportAs"
            :items="exportAsTypes"
            label="Export As"
            class="mt-6"
            dense
          ></v-select>
        </div>
        </v-toolbar>
      </v-menu>

      <v-menu
        bottom
        left
        :close-on-click="true"
        :close-on-content-click="false"
        offset-y
      >
        <template v-slot:activator="{ on }">
          <v-btn color icon v-on="on">
            <v-icon>{{ getStateIcon(stateFilter) }}</v-icon>
          </v-btn>
        </template>
        <v-sheet class="pa-4" style="min-width: 600px">
          <div class="subtitle-1 mb-2">Show Messages</div>
          <v-slider
            v-model="stateFilter"
            :tick-labels="state"
            :max="4"
            step="1"
            ticks="always"
            tick-size="5"
          ></v-slider>
        </v-sheet>
      </v-menu>

      <div>{{ dateFilter }}</div>
      <v-menu
        ref="datePicker"
        class="d-flex"
        v-model="datePicker"
        :close-on-content-click="false"
        :return-value.sync="dateFilterRange"
        transition="scale-transition"
        offset-y
        min-width="250px"
      >
        <template v-slot:activator="{ on }">
          <v-btn color icon v-on="on">
            <v-icon>mdi-calendar</v-icon>
          </v-btn>
        </template>
        <v-date-picker v-model="dateFilterRange" no-title scrollable range>
          <v-spacer></v-spacer>
          <v-btn
            text
            color="primary"
            @click="datePicker = false"
            >Cancel</v-btn
          >
          <v-btn text color="primary" @click="$refs.datePicker.save(dateFilterRange)"
            >OK</v-btn
          >
        </v-date-picker>
      </v-menu>

      <v-menu
        bottom
        left
        :close-on-click="true || !actionFilter || !actionFilter.length"
        :close-on-content-click="false"
        :offset-y="false"
      >
        <template v-slot:activator="{ on }">
          <v-btn :color="actionFilter && actionFilter.length ? 'primary' : ''" icon v-on="on">
            <v-icon>mdi-filter</v-icon>
          </v-btn>
        </template>
        <v-toolbar flat dense :min-width="500" :max-width="600">
          <v-select
            class="mt-5"
            v-model="actionFilter"
            :items="actions"
            clearable
            multiple
            prepend-icon="mdi-filter"
            item-text="name"
            item-value="id"
            label="Filter by action..."
            dense
            single-line
            filled
          ></v-select>
          <v-select
            class="mt-5 ml-4"
            v-model="statusFilter"
            :items="statuses"
            label="Filter by status..."
            clearable
            dense
            single-line
            filled
          ></v-select>
        </v-toolbar>
      </v-menu>

      <v-menu
        bottom
        left
        :close-on-click="!search"
        :close-on-content-click="false"
        :offset-y="false"
      >
        <template v-slot:activator="{ on }">
          <v-btn color icon v-on="on">
            <v-icon>mdi-magnify</v-icon>
          </v-btn>
        </template>
        <v-toolbar flat dense :min-width="550" :max-width="800">
          <v-text-field
            v-model="search"
            hide-details
            prepend-icon="mdi-magnify"
            flat
            clearable
            single-line
            filled
            placeholder="Search first/last name, cell number, reference or message content..."
          ></v-text-field>
        </v-toolbar>
      </v-menu>
    </v-toolbar>
    <Confirm
      :confirm.sync="confirmDelete"
      :callback="deleteMessages"
      :message="`Are you sure you want to <b>permanently delete</b> these ${selectedMessages.length} messages?`"
    ></Confirm>

    <v-data-table
      v-model="selectedMessages"
      :items="messages"
      :headers="headers"
      :search="search"
      :page.sync="page"
      :options.sync="tableOptions"
      :items-per-page.sync="itemsPerPage"
      :server-items-length="messagesTotal"
      :footer-props="{ 'items-per-page-options': [10, 20, 50, 100] }"
      :show-group-by="false"
      :must-sort="true"
      :loading="messagesLoading"
      @click:row="messageClick"
      class="elevation-1"
      show-select
    >
      <template v-slot:[`item.starred`]="{ item }">
        <v-icon>{{ item.read ? "mdi-email-open" : "mdi-email" }}</v-icon>
        <v-icon v-if="item.completed" class="ml-1">mdi-check</v-icon>
        <v-icon v-if="item.starred" class="ml-1">mdi-star</v-icon>
        <v-icon v-if="item.location" class="ml-1">mdi-map-marker</v-icon>
        <v-icon
          class="ml-1"
          v-if="item.approved !== null"
          :color="item.approval_by_id ? 'success' : 'warning'"
          >{{ item.approved ? "mdi-check" : "mdi-cancel" }}</v-icon
        >
      </template>
      <template v-slot:[`item.name`]="{ item }">
        <div v-if="user(item)" dark>
          {{ user(item).first_name }} {{ user(item).last_name }}
        </div>
      </template>
      <template v-slot:[`item.action`]="{ item }">
        <div class="text-truncate">
          {{ getActionIcon(item.action_id) }}
          {{ getActionProp(item.action_id, "name") }}
        </div>
      </template>
      <template v-slot:[`item.message`]="{ item }">
        <div v-if="item.message && item.message.text">
          {{ item.message.text | truncate }}
        </div>
      </template>
      <template v-slot:[`item.elaborated`]="{ item }">
        <div v-html="$options.filters.truncate(item.elaborated, 50)"></div>
      </template>
      <template v-slot:[`item.reference`]="{ item }">
        <div>
          {{ item.reference || '-' }}
        </div>
      </template>
      <template v-slot:[`item.created_at`]="{ item }">
        <div dark>{{ dateFormat(item.created_at) }}</div>
      </template>
    </v-data-table>

    <Message
      :message.sync="selectedMessage"
      :removed.sync="messageRemoved"
    ></Message>
  </section>
</template>

<script>
import { botClient } from "@/bot";
import moment from "moment";
import { mapActions, mapState, mapGetters } from "vuex";
import { makeFindMixin } from "feathers-vuex";
import Message from "@/components/messages/Message";
import Confirm from "@/components/widget/Confirm";

export default {
  data: () => ({
    page: 1,
    pageCount: 0,
    itemsPerPage: 10,
    selectedMessage: {},
    selectedMessages: [],
    sort: {},
    search: "",
    actionFilter: null,
    statusFilter: null,
    datePicker: null,
    dateFilterRange: [],
    useDateFilter: true,
    stateFilter: 0,
    showFilters: false,
    messageRemoved: false,
    confirmDelete: false,
    state: ["All", "Unread", "Read", "Starred", "Completed"],
    stateIcons: [
      "mdi-eye",
      "mdi-email",
      "mdi-email-open",
      "mdi-star",
      "mdi-check",
    ],
    exportAs: 'CSV',
    exportAsTypes: ['CSV', 'KML'],
    statuses: ["new", "priority", "in progress", "unassigned", "assigned"],
    headers: [
      { text: "", value: "starred", sortable: false },
      { text: "From", value: "name" },
      { text: "Cell", value: "member.cell" },
      { text: "Action", value: "action" },
      { text: "Message", value: "message" },
      { text: "Elborated", value: "elaborated" },
      { text: "Status", value: "status" },
      { text: "Reference", value: "reference" },
      { text: "Date", value: "created_at" },
    ],
    tableOptions: {},
  }),
  mixins: [
    makeFindMixin({ service: "messages", watch: true }),
    makeFindMixin({ service: "actions" }),
  ],
  computed: {
    ...mapGetters("config", ["botApiUrl"]),
    ...mapState("apiAuth", ["accessToken"]),
    messagesLoading() {
      return this.isFindMessagesPending;
    },
    dateFilter() {
      return this.dateFilterRange && this.dateFilterRange.length === 1 
        ? this.dateFilterRange[0] 
        : this.dateFilterRange && this.dateFilterRange.length === 2 
          ? `${this.dateFilterRange[0]} - ${this.dateFilterRange[1]}`
          : null;
    },
    messagesTotal() {
      return (
        this.messagesPaginationData.default &&
        this.messagesPaginationData.default.mostRecent.total
      );
    },
    messagesParams() {
      let query = {
        $limit: this.itemsPerPage,
        $skip: (this.page - 1) * this.itemsPerPage,
        $sort: this.sort,
      };

      if (this.search && this.search.length) {
        query.$or = [
          {
            member: {
              first_name: { $regex: this.search || "", $options: "i" },
            },
          },
          {
            member: {
              last_name: { $regex: this.search || "", $options: "i" },
            },
          },
          { member: { cell: { $regex: this.search || "", $options: "i" } } },
          { elaborated: { $regex: this.search || "", $options: "i" } },
          { data: { $regex: this.search || "", $options: "i" } },
          { message: { text: { $regex: this.search || "", $options: "i" } } },
          { reference: { $regex: this.search || "", $options: "i" } },
        ];
      }

      if (this.actionFilter && this.actionFilter.length) {
        query.action_id = {
          $in: this.actionFilter,
        };
      }

      if (this.statusFilter) {
        query.status = this.statusFilter;
      }

      if (this.stateFilter && this.stateFilter < 3) {
        query.read = this.stateFilter === 1 ? false : true;
      }
      if (this.stateFilter === 3) {
        query.starred = true;
      }
      if (this.stateFilter === 4) {
        query.completed = true;
      }

      if (!this.datePicker && this.dateFilterRange && this.dateFilterRange.length && this.useDateFilter) {
        let from = moment(this.dateFilterRange[0]).startOf("day").toISOString();
        let to = moment(this.dateFilterRange[1]).startOf("day").toISOString();
        query.created_at = {
          $gt: from,
          $lte: to,
        };
      }

      return {
        query: query,
      };
    },
    messagesFetchParams() {
      let query = {
        $eager: "[member]",
        $joinRelation: "[member]",
        $limit: this.itemsPerPage,
        $skip: (this.page - 1) * this.itemsPerPage,
        $sort: this.sort,
      };

      if (this.search && this.search.length) {
        query.$or = [
          { member: { first_name: { $ilike: `%${this.search || ""}%` } } },
          { member: { last_name: { $ilike: `%${this.search || ""}%` } } },
          { member: { cell: { $ilike: `%${this.search || ""}%` } } },
          { elaborated: { $ilike: `%${this.search || ""}%` } },
          { data: { $ilike: `%${this.search || ""}%` } },
          { message: { text: { $ilike: `%${this.search || ""}%` } } },
          { reference: { $ilike: `%${this.search || ""}%` } },
        ];
      }

      if (this.actionFilter && this.actionFilter.length) {
        query.action_id = {
          $in: this.actionFilter,
        };
      }

      if (this.statusFilter) {
        query.status = this.statusFilter;
      }

      if (this.stateFilter && this.stateFilter < 3) {
        query.read = this.stateFilter === 1 ? false : true;
      }
      if (this.stateFilter === 3) {
        query.starred = true;
      }
      if (this.stateFilter === 4) {
        query.completed = true;
      }

      if (!this.datePicker && this.dateFilterRange && this.dateFilterRange.length && this.useDateFilter) {
        let from = moment(this.dateFilterRange[0])
          .startOf("day")
          .format("YYYY-MM-DD HH:mm:ss.SS");
        let to = moment(this.dateFilterRange[1])
          .startOf("day")
          .format("YYYY-MM-DD HH:mm:ss.SS");
        query["messages.created_at"] = {
          $gt: from,
          $lte: to,
        };
      }

      return {
        query: query,
        debounce: 700,
      };
    },
    actionsParams() {
      return {
        query: {
          $select: ["id", "name", "description", "properties"],
        },
      };
    },
  },
  mounted() {
    this.tableOptions = {
      sortBy: ["created_at"],
      sortDesc: [true],
    };
  },
  methods: {
    ...mapActions("app", ["showMessage"]),
    exportURL(what = 'all') {
      let exportUrl = new URL(
        botClient.service('messages').path,
        this.botApiUrl || process.env.VUE_APP_API_URL
      ).toString();

      exportUrl = `${exportUrl}?$export=${what}`;
      if (this.exportAs === 'KML') exportUrl += '&$kml=true'
      if (what === 'action_filtered' && this.actionFilter && this.actionFilter.length) exportUrl += `&action_ids=${this.actionFilter.join(',')}`;
      if (this.dateFilterRange && this.dateFilterRange.length) exportUrl += `&date_from=${this.dateFilterRange[0]}&date_to=${this.dateFilterRange[1]}`;
      exportUrl += `&access_token=${this.accessToken}`;

      return exportUrl;
    },
    dateFormat(date) {
      return moment(date).format("YYYY-MM-DD HH:mm");
    },
    messageClick(message) {
      this.selectedMessage = message;
    },
    toggleFilters() {
      this.showFilters = this.showFilters === 0 ? -1 : 0;
    },
    getStateIcon(state) {
      return this.stateIcons[state];
    },
    getActionProp(id, prop) {
      let action = this.actions.find((action) => action.id === id);
      return action && action[prop] ? action[prop] : null;
    },
    getActionIcon(id) {
      let action = this.actions.find((action) => action.id === id);
      return action && action.properties && action.properties.icon
        ? action.properties.icon
        : null;
    },
    user(item) {
      return (item && item.member) || (item.message && item.message.from);
    },
    async deleteMessages() {
      let messageIds = this.selectedMessages.map((message) => message.id);
      try {
        await botClient
          .service("messages")
          .remove(null, { query: { id: { $in: messageIds } } });

        await this.findMessages();
        this.selectedMessages = [];
      } catch (error) {
        this.showMessage({
          text: error.message || "Error occured!",
          color: "error",
        });
      }
    },
  },
  watch: {
    tableOptions(now, before) {
      if (now.sortBy !== before.sortBy && now.sortBy.length) {
        this.sort = {};
        now.sortBy.forEach((sorter, index) => {
          this.sort[sorter] = now.sortDesc[index] ? -1 : 1;
        });
      }
    },
    messageRemoved(now) {
      if (now) {
        this.findMessages();
        this.messageRemoved = false;
      }
    },
    datePicker(openNow, openBefore) {
      if (!openNow && this.dateFilterRange.length === 1) this.dateFilterRange.push(moment().endOf("day").format("YYYY-MM-DD"))
      if (!openBefore && openNow) this.dateFilterRange = []
      else if (openBefore && !openNow) this.dateFilterRange = []
    }
    /*messages(now, before) {
      if (now && before && now.length !== before.length) {
        this.findMessages();
      }
    },*/
  },
  components: {
    Message,
    Confirm,
  },
};
</script>

<style lang="scss" scoped>
.attention {
  font-weight: bold;
}
</style>